import React, { useEffect, useState } from 'react'
import './index.less'
import { PaintingCard } from '@/components/PaintingCard'
import { getInstituteWorkByCriteria } from '@/server'
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import {
  setInfoKey,
  setInfoValue,
  setShowType
} from '@/features/SetIndexSecondInfo/setIndexSecondInfo'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { upArrow } from '@/assets/images'
import { getPaintingCardTrackStyle, usePaintingCardsPerPage } from '../paintingCardCarousel'

const continentArr = ['亚洲', '欧洲', '北美洲']

export function Museum() {
  // redux获取token
  const token = useAppSelector((state) => state.login.token)
  // redux配置
  const dispatch = useAppDispatch()
  // react-router配置
  const _navigate = useNavigate()
  const cardsPerPage = usePaintingCardsPerPage()
  // 展示内容
  const [showContent, setShowContent] = useState<any[]>([])
  // 当前展示页码
  const [page, setPage] = useState<number>(1)
  // 总页码
  const [total, setTotal] = useState<number>(0)

  // 每次加载一页的长度
  const museumsPerPage = 10
  // 距离底部多少像素时预加载下一页
  const loadMoreDistance = 600
  // 是否正在请求数据，避免滚动时重复触发
  const [loading, setLoading] = useState<boolean>(false)
  // 吸顶图标显隐控制
  const [topDisplay, setTopDisplay] = useState(false)
  // 每个展示列表中第一个作品的index
  const [showIndex, setShowIndex] = useState<number[]>(
    new Array(Object.keys(showContent).length).fill(0)
  )
  // 展示机构所属大洲
  const [showContinent, setShowContinent] = useState('亚洲')
  /**
   * 获取数据
   * @param changeContinent: 是否切换大洲，一些状态需要重置，默认不切换
   * @returns
   */
  function appendData(changeContinent = false) {
    if (!changeContinent && loading) return
    setLoading(true)

    getInstituteWorkByCriteria(
      {
        criteria: [
          {
            key: 'continent',
            value: showContinent
          }
        ],
        pages: {
          page: changeContinent ? 1 : page,
          size: museumsPerPage
        }
      },
      token
    )
      .then((res) => {
        setShowContent((prevShowContent) =>
          changeContinent ? res.data.content.list : [...prevShowContent, ...res.data.content.list]
        )
        setTotal(res.data.content.total)
        setPage(changeContinent ? 2 : page + 1)
        setShowIndex((prevShowIndex) =>
          changeContinent
            ? new Array(museumsPerPage).fill(0)
            : [...prevShowIndex, ...new Array(museumsPerPage).fill(0)]
        )
      })
      .finally(() => setLoading(false))
  }

  // 初始化
  useEffect(() => {
    appendData(true)
  }, [showContinent])

  /**
   * 柯里化函数，封装节流功能，在delay时间段内，fun只能执行一次
   * @param fun: 被封装的函数
   * @param delay: 时间阈值
   * @returns function 节流版本的fun
   */
  function throttle(fun, delay) {
    let last
    return function () {
      //@ts-ignore
      const that = this
      const _args = arguments
      const now = +new Date()
      if (last && now < last + delay) {
        // clearTimeout(tickRef.current)
        // //@ts-ignore
        // tickRef.current = setTimeout(function () {
        //   last = now
        //   fun.apply(that, _args)
        // }, delay)
      } else {
        last = now
        fun.apply(that, _args)
      }
    }
  }
  useEffect(() => {
    // 1000ms的节流版appendData
    const throttleAjax = throttle(appendData, 1000)
    // 监听屏幕滚动高度，触发加载数据函数以及吸顶图标的显隐
    const handleScroll = function () {
      const scrollElement = document.body
      // 真实内容高度
      const pageHeight = scrollElement.scrollHeight
      // 视窗高度
      const viewportHeight = scrollElement.clientHeight || window.innerHeight || 0
      // 上面隐藏的高度
      const scrollHeight = scrollElement.scrollTop
      const distanceToBottom = pageHeight - viewportHeight - scrollHeight
      const hasMore = showContent.length < total
      // 通过 真实内容高度 - 视窗高度 - 上面隐藏的高度 < 某阈值，作为加载下一页数据的触发条件
      if (distanceToBottom >= 0 && distanceToBottom <= loadMoreDistance && hasMore && !loading) {
        throttleAjax()
      }
      if (scrollHeight > 1500) {
        setTopDisplay(true)
      } else {
        setTopDisplay(false)
      }
    }
    document.body.addEventListener('scroll', handleScroll)
    return () => {
      document.body.removeEventListener('scroll', handleScroll)
    }
  }, [page, total, showContinent, token, showContent.length, loading])
  /**
   * 向小序号翻页
   * @param id: 对应DOM的id
   * @param index: 对应DOM的位序
   * @returns
   */
  const handlePre = function (index: number) {
    const newIndex = showIndex.map((x, i) => {
      if (i === index) {
        return x - cardsPerPage < 0 ? 0 : x - cardsPerPage
      } else return x
    })
    setShowIndex(newIndex)
  }

  /**
   * 向大序号翻页
   * @param id: 对应DOM的id
   * @param index: 对应DOM的位序
   * @returns
   */
  const handleNext = function (index: number, len: number) {
    const newIndex = showIndex.map((x, i) => {
      if (i === index) {
        return Math.min(x + cardsPerPage, Math.max(0, len - cardsPerPage))
      } else return x
    })
    setShowIndex(newIndex)
  }

  // 查看详情的回调，传给二级页面相应配置
  function handleIndexSecondPage(museum) {
    dispatch(setShowType('painting'))
    dispatch(setInfoKey('institute'))
    dispatch(setInfoValue(museum))
    // navigate("./indexSecond")
    window.open('/indexSecond')
  }

  return (
    <div className='museum-container'>
      <div className='category-select'>
        {continentArr.map((d) => (
          <div
            className={
              showContinent === d ? 'category-item category-item-selected' : 'category-item'
            }
            onClick={() => setShowContinent(d)}
          >
            {d}
          </div>
        ))}
      </div>
      <div
        className='back-to-top'
        onClick={() => (document.body.scrollTop = 0)}
        style={{ visibility: topDisplay ? 'visible' : 'hidden' }}
      >
        <img src={upArrow}></img>
      </div>
      <div className='continent-content'>
        {showContent.map((museum, index) => (
          <div className='museum'>
            <div className='museum-title'>
              <div className='museum-name'>{museum.instname}</div>
              <div className='btn-box'>
                <div
                  className={'btn ' + (showIndex[index] === 0 ? 'disabled' : 'abled')}
                  onClick={(_e) => handlePre(index)}
                >
                  <ArrowLeftOutlined
                    style={{
                      margin: 'auto',
                      color: showIndex[index] === 0 ? 'rgb(180, 179, 173)' : 'rgb(72, 66, 51)'
                    }}
                  />
                </div>
                <div
                  className={
                    'btn ' +
                    (showIndex[index] >= Math.max(0, museum.workDto.length - cardsPerPage)
                      ? 'disabled'
                      : 'abled')
                  }
                  onClick={(_e) => handleNext(index, museum.workDto.length)}
                >
                  <ArrowRightOutlined
                    style={{
                      margin: 'auto',
                      color:
                        showIndex[index] >= Math.max(0, museum.workDto.length - cardsPerPage)
                          ? 'rgb(180, 179, 173)'
                          : 'rgb(72, 66, 51)'
                    }}
                  />
                </div>
              </div>
            </div>
            <div className='museum-subtitle'>
              <div className='museum-count'>共计 {museum.workNum} 件作品</div>
              <div className='check-all-btn' onClick={() => handleIndexSecondPage(museum.instname)}>
                查看所有画作
                <ArrowRightOutlined
                  style={{
                    color: 'rgb(72, 66, 51)',
                    fontSize: '14px'
                  }}
                />
              </div>
            </div>
            <div className='painting-card-viewport'>
              <div className='museum-content' style={getPaintingCardTrackStyle(showIndex[index])}>
                {museum.workDto.map((work) => (
                  <PaintingCard
                    title={work.workname}
                    dynasty={work.dynasty}
                    author={work.authorname}
                    museum={''}
                    image={work.encoding}
                    id={work.workid}
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div
        className='end-line-container'
        style={{
          display: museumsPerPage * (page - 1) < total ? 'none' : 'flex'
        }}
      >
        <div className='end-line'></div>
        已经到底了
        <div className='end-line'></div>
      </div>
    </div>
  )
}
